import React, { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { useLanguage } from '@hydrogen/elements.core.i18n';
import {
    MultilineText,
    Icon,
    ICON_SIZE_NAMES,
    IconNames,
    ConfirmModal,
    Heading, BulletList, ListItem,
} from '@dekafvv/sharedfrontend';

export const ForgotPasswordSuccess: React.FC<Props> = ({ onClose, setIsProgressBarHidden }) => {
    const { t } = useLanguage();

    const confirmButton = {
        onClick: onClose,
        title: t('button.close'),
    };

    useEffect(() => {
        setIsProgressBarHidden(true);
    }, []);

    return (
        <ConfirmModal
            visible
            onClose={onClose}
            confirmButton={confirmButton}
            closeIcon
        >
            <Icon
                name={IconNames.checkCircle}
                size={ICON_SIZE_NAMES.xl}
                className="mt-8"
                color="var(--positive-default)"
            />
            <Heading textAlign="center" size={2}>
                {t('wizard.forgot-password.notification.header')}
            </Heading>
            <MultilineText fontWeight="bold">
                <Trans
                    i18nKey={t('wizard.forgot-password.notification.text')}
                    components={{
                        ul: <BulletList />,
                        li: <ListItem />,
                    }}
                />
            </MultilineText>
        </ConfirmModal>
    );
};

type Props = {
  onClose: () => void;
  setIsProgressBarHidden: (isHidden: boolean) => void;
};
